import React from 'react';
import PropTypes from 'prop-types';
import Chip from "@material-ui/core/Chip";
import {Icon,withStyles} from "@material-ui/core";


const CustomChip = withStyles({
    root: {
        background: "none",
        // borderRadius: "10px",
        fontFamily: "Metropolis",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "12px",
        lineHeight: "12px",
        color: "var(--color-gray-600)"
    }
})(Chip);

function CustomChip2(props) {
    return (
        <div>
            <CustomChip {...props} deleteIcon={<Icon fontSize="small">close</Icon>}/>
        </div>
    );
}

CustomChip2.propTypes = {};
CustomChip2.defaultProps = {};

export default CustomChip2;
